import { camelCase, validateWebUrl, addTransferProtocol, validatePassword,
    validateSlug, convertSlug, testReservedSlugs,
    extrapolateInterest, fixCurrency, convertImage, validateEmailAddress,
    userCanList, extractHostname, copyToClipboard,
    formatNumberToString, deriveListSlug, encodeForURI } from './random';
import { parseYouTubeUrl, convertYouTubeIdToImg } from './video';

Object.constrain = function ( sourceObject={}, templateObjectOrArray=[] ) {
    var keys = [];
    var result = {};
    if( templateObjectOrArray.length !== undefined ) {
        //it's an array, treat it as the list of keys
        keys = templateObjectOrArray;
    } else {
        //it's an object, get the keys
        keys = Object.keys( templateObjectOrArray );
    }
    for ( var key of keys ) {
        if( sourceObject[ key ] !== undefined ) {
            result[ key ] = sourceObject[ key ];
        }
    }
    return result;
};
Object.decodeURLQuery = function( queryString ) {
    var qs;
    if( queryString.charAt( 0 ) === '?' ) {
        qs = queryString.slice( 1 ).split( '&' );
    } else {
        qs = queryString.split( '&' );
    }
    var ret = qs.reduce( ( obj, curr ) => {
        var spt = curr.split( '=' );
        obj[spt[0]] = decodeURIComponent( spt[1] || '' );
        return obj;
    }, {} );
    return ret;
};
Object.encodeURLQuery = function( obj ) {
    var k = Object.keys( obj );
    let l = k.length;
    if( l === 0 ) {
        return '';
    }
    var ret = k.reduce( (p, c, i) => {
        p += encodeURIComponent( c.toString() ) + '=' + encodeURIComponent( obj[ c ].toString() );
        if( ( i + 1 ) < l ) {
            p += '&';
        }
        return p;
    }, '?' );
    return ret;
};

String.prototype.hashCode = function() {
    var hash = 0, i, chr, len;
    if (this.length === 0) return hash;
    for (i = 0, len = this.length; i < len; i++) {
        chr   = this.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

export const digitizeDuration = function( dur, milli ) {
    let h = dur.hours();
    let m = dur.minutes();
    let s = dur.seconds();
    let ms = dur.milliseconds();

    h = h < 10 ? `0${ h }` : h.toString();
    m = m < 10 ? `0${ m }` : m.toString();
    s = s < 10 ? `0${ s }` : s.toString();

    if( milli ) {
        return `${ h }:${ m }:${ s }.${ ms }`;
    }
    return `${ h }:${ m }:${ s }`;
};

export {
    camelCase,
    validateWebUrl,
    addTransferProtocol,
    validatePassword,
    validateEmailAddress,
    validateSlug,
    convertSlug,
    testReservedSlugs,
    extrapolateInterest,
    formatNumberToString,
    fixCurrency,
    convertImage,
    convertYouTubeIdToImg,
    userCanList,
    parseYouTubeUrl,
    extractHostname,
    deriveListSlug,
    copyToClipboard,
    encodeForURI,
};

//v4
export { cutBranch } from './tree';
export * from './constants';
